import React from 'react'
import { Grid } from '@material-ui/core'
import useLookupClient from '../../../services/lookupClient/useLookupClient'
import { useFormState } from 'react-final-form'
import MySelect from '../../../control/select/select'
import useTranslate from '../../../i18n/useTranslate'

const DocumentRequire: React.FC = () => {
    const lookupClient = useLookupClient()
    const translate = useTranslate()
    const { values } = useFormState()

    const options = lookupClient.getNeedDoc()

    return (
        <Grid container spacing={2}>
            <Grid item xs={12} md={4}>
                <MySelect
                    name="fullBoard"
                    label={translate.get('UM.SETTING_SYSTEM.FULL_BOARD')}
                    option={options}
                    size="small"
                    placeholder={'fullBoard'}
                    defaultValue={[values.fullBoard]}
                />
            </Grid>

            <Grid item xs={12} md={4}>
                <MySelect
                    name="expedite"
                    label={translate.get('UM.SETTING_SYSTEM.EXPEDITE')}
                    option={options}
                    size="small"
                    placeholder={'expedite'}
                    defaultValue={[values.expedite]}
                />
            </Grid>

            <Grid item xs={12} md={4}>
                <MySelect
                    name="exempt"
                    label={translate.get('UM.SETTING_SYSTEM.EXEMPT')}
                    option={options}
                    size="small"
                    placeholder={'exempt'}
                    defaultValue={[values.exempt]}
                />
            </Grid>
        </Grid>
    )
}

export default DocumentRequire
